import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { OffersService } from "service/offers/offers.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LanguageService } from "service/translate/translate.service";
import { UseService } from "service/users/use.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationToastrService } from "service/notification-toastr/notification-toastr.service";
import { TranslateService } from "@ngx-translate/core";
import { ToolService } from "service/tool/tool.service";
import { FormatDateService } from "service/format-date/format-date.service";
import { CopyService } from "service/copy/copy.service";
import { QRCodeErrorCorrectionLevel } from "angularx-qrcode";

@Component({
  selector: "app-detail-offer",
  templateUrl: "./detail-offer.component.html",
  styleUrls: ["./detail-offer.component.scss"],
})
export class DetailOfferComponent implements OnInit, AfterViewInit {
  detailOffer: any;
  offerImage: string;
  offerName: string;
  offerPayout: any;
  offerTag: any;
  offerType: string;
  offerCountries: any[];
  offerId: any;
  checkLanguage: string | null;
  descriptionOb: any = [];
  heightCardDes: any;
  similarOffers: any[] = [];
  landingPages: any[];
  selectedLandingPage: any;
  typeLandingPage: any;
  parseTrackingDomain: any;
  affiliateId: number;
  loadDetailPage: boolean = true;
  loadSimilarOffer: boolean = true;
  activeIds: any = ["panel-0", "panel-1"];
  subIdChecked: boolean = true;
  affClickIdChecked: boolean = true;
  mobileParamsChecked: boolean = true;
  checkOrderApi: any;
  orderSendApiUrl = "https://api.dinos.vn/api/v1/system_v2";
  orderSendApi: any;
  trackingLink: any;
  impressionsPixel: string;
  stringSubId: string;
  trackingLinkFull: string;
  stringMobileParams: string;
  valueLink: string;
  sortTrackingLink: string;
  originalTrackingLink: string;
  isResponsive: boolean;
  isMobile: boolean;
  checkCardEcommerce: boolean;
  checkLenghtOfferTag: boolean = true;
  isTabView: boolean;
  visitPage: any;
  countConversion: any;
  noDataSimilarOffer: boolean = false;
  enableDirectLink: boolean = false;
  directLink: string = "";
  qrData: string = ""; // Url
  size: number = 400; // Kích thước QR Code
  level: QRCodeErrorCorrectionLevel = "M"; // Độ chính xác (L, M, Q, H)

  public trackingDomains: { title: string; value: string; id: number }[];
  public selectedTrackingDomain: string;

  params = {
    availability: "",
    countries: "",
    goalsTypes: "",
    onlyFeatured: undefined,
    onlyMine: undefined,
    page: 1,
    perPage: 4,
    search: "",
    sortDirection: "desc",
    sortField: "id",
    tags: "",
  };

  subIds = [
    {
      id: "sub_id1",
      title: "Sub ID 1",
      value: "",
    },
    {
      id: "sub_id2",
      title: "Sub ID 2",
      value: "",
    },
  ];

  affClickId = {
    id: "aff_click_id",
    title: "Affiliate click ID",
    value: "",
  };

  mobileParams = [
    {
      id: "idfa",
      title: "Apple ios idfa",
      value: "",
    },
    {
      id: "gaid",
      title: "Google android gaid",
      value: "",
    },
  ];

  disableButtonUpgradeOffer: boolean = true;
  timeoutId: any;
  updateRouteNavigated: boolean = false;
  checkTrackingLink: boolean = true;
  payoutExclusive: number;
  historyData: any;
  loadHistory: boolean = true;
  exclusivePackageName: any;
  checkDirectLink: boolean = true;

  paramUpdate = {
    page: 1,
    perPage: 10,
    affiliate_id: 0,
    offer_id: 0,
    rangeFrom: "",
    rangeTo: "",
  };
  historyDataAll: any;
  visibleTypeSelect: any;
  loadRequest: boolean = false;

  @ViewChild("hiddenQrCode", { static: false }) hiddenQrCode!: ElementRef;
  @ViewChild("modalGenerateQr") modalGenerateQr!: ElementRef;

  constructor(
    private languageService: LanguageService,
    private offerServices: OffersService,
    private activeRouter: ActivatedRoute,
    private userService: UseService,
    private modalService: NgbModal,
    private toastr: NotificationToastrService,
    private translate: TranslateService,
    private router: Router,
    private toolService: ToolService,
    private formatDateService: FormatDateService,
    private copyService: CopyService
  ) {
    this.isResponsive = window.matchMedia("(max-width: 1280px)").matches;
    this.isMobile = window.matchMedia("(max-width: 767px)").matches;
    this.isTabView = window.matchMedia("(max-width: 1080px)").matches;
  }

  ngOnInit() {
    this.paramUpdate.rangeFrom = "01.01.2020";
    this.paramUpdate.rangeTo = this.formatDateService.formatDate(
      new Date(),
      "DATE.MONTH.YEAR"
    );
    this.userService.getUserProfile().subscribe((data) => {
      this.paramUpdate.affiliate_id = data.id;
    });
    this.getListHistory(this.paramUpdate);

    this.getIdAffiliate();
    this.languageService.languageChanged.subscribe((language) => {
      this.checkLanguage = language;
    });
    this.checkLanguage = localStorage.getItem("selectedLanguage");
    this.offerId = this.activeRouter.snapshot.params["id"];
    this.checkCardEcommerce =
      this.offerId == 262 || this.offerId == 263 || this.offerId == 425;
    this.getDetailOffer();
    this.getListHistoryUpdate(this.paramUpdate);
    this.changeTrackingLink();
    this.createLink();
  }

  @ViewChild("modalUpgrade") modalUpgrade: TemplateRef<any>;

  openModal() {
    this.modalService.open(this.modalUpgrade, {
      scrollable: true,
      centered: true,
    });
  }

  ngAfterViewInit() {
    // this.checkOpenModal();
    this.handleHeightCardDes();
  }

  checkOpenModal() {
    this.visitPage = localStorage.getItem("visitPage_" + this.offerId);
    if (this.visitPage) {
      this.visitPage = Number(this.visitPage) + 1;
    } else {
      this.visitPage = 1;
    }

    localStorage.setItem(
      "visitPage_" + this.offerId,
      this.visitPage.toString()
    );
    this.offerServices.getDetailOffer(this.offerId).subscribe((data) => {
      if (data?.exclusive_commission == 1) {
        this.userService.getDataConversion(data).subscribe((data) => {
          this.countConversion = data?.length;
          if (
            (this.countConversion > 20 || this.visitPage >= 5) &&
            !this.disableButtonUpgradeOffer &&
            !this.updateRouteNavigated
          ) {
            this.timeoutId = setTimeout(() => {
              this.openModal();
            }, 60000);
          }
        });
      }
    });
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.isResponsive = window.matchMedia("(max-width: 1280px)").matches;
    this.isMobile = window.matchMedia("(max-width: 767px)").matches;
    this.isTabView = window.matchMedia("(max-width: 1080px)").matches;
    this.handleHeightCardDes();
  }

  routerUpdateOffer() {
    if (this.detailOffer?.exclusive_commission == 1) {
      clearTimeout(this.timeoutId);
      this.updateRouteNavigated = true;
      this.loadSimilarOffer = true;
      this.router.navigate([`offers/detail/${this.offerId}/update`]).then();
      this.modalService.dismissAll();
    } else {
      this.router
        .navigate([`offers/detail/${this.offerId}/update/history`])
        .then();
    }
  }

  navigateToDetail(id: any) {
    const url = "/detail/" + id;
    const urlOrigin = window.location.href.replace(/(\/detail\/)(\d+)/, url);
    window.open(urlOrigin, "_blank");
  }

  checkPayoutRegisteredButOff(): boolean {
    return (
      this.detailOffer?.register_exclusive &&
      this.detailOffer?.exclusive_commission !== 1
    );
  }

  checkPayoutSpecial(item: any): boolean {
    return item?.register_exclusive;
  }

  checkOfferRequest(): boolean {
    return (
      this.detailOffer?.visible_type == 2 &&
      (this.visibleTypeSelect?.status != 1 ||
        !this.detailOffer?.visible_type_selected[0]?.availability) &&
      this.detailOffer?.visible_type_selected[0]?.availability !== "approved"
    );
  }

  checkOfferRequesting() {
    const requests = this.detailOffer.visible_type_selected[0].requests;
    return requests.some((request: any) => request?.status == 2);
  }

  getPayout(item: any): any {
    return (
      item["goals"][0]["payout_for_affiliate"] || item["goals"][0]["payout"]
    );
  }

  payoutRegistered(item: any) {
    if (this.historyDataAll) {
      let result = this.historyDataAll.filter(
        (h: any) => h.offer_id == item?.id && this.conditionOfferRegistered(h)
      );

      if (result?.length > 0) {
        return result[0].payout_exclusive;
      }
    }
    return (
      item["goals"][0]["payout_for_affiliate"] || item["goals"][0]["payout"]
    );
  }

  getListHistory(params: any) {
    this.toolService.getListUpdateHistory(params).subscribe((data) => {
      this.historyDataAll = data?.data;
    });
  }

  async getListHistoryUpdate(params: any) {
    await this.getIdAffiliate();
    params.rangeFrom = "01.01.2020";
    params.rangeTo = this.formatDateService.formatDate(
      new Date(),
      "DATE.MONTH.YEAR"
    );
    params.affiliate_id = this.affiliateId;
    params.offer_id = this.offerId;

    if (params.affiliate_id && params.offer_id) {
      this.toolService.getListUpdateHistory(params).subscribe(
        (data) => {
          let results = data?.data.filter((r: any) =>
            this.conditionOfferRegistered(r)
          );

          this.historyData = results;
          this.payoutExclusive = this.historyData[0]?.payout_exclusive;
          this.exclusivePackageName = this.historyData[0]?.tittle_package;
          this.loadHistory = false;
        },
        () => {
          this.loadHistory = false;
        }
      );
    }
  }

  conditionOfferRegistered(item: any) {
    let today = this.formatDateService.formatDate(new Date(), "YEAR-MONTH-DAY");
    return (
      item?.check_done == 0 &&
      item?.start_time_local <= today &&
      today <= item?.end_time_local &&
      (item?.status_payment_bank == 2 || item?.status_payment_bank == 3)
    );
  }

  handleSubIdCheckbox(event: any) {
    this.subIdChecked = event.target.checked;
    this.resetSubId();
  }

  addSubId() {
    if (this.subIds.length !== 5) {
      const obj = {
        id: `sub_id${this.subIds.length + 1}`,
        title: `Sub ID ${this.subIds.length + 1}`,
        value: "",
      };
      this.subIds.push(obj);
    }
  }

  resetSubId() {
    this.subIds = [
      {
        id: "sub_id1",
        title: "Sub ID 1",
        value: "",
      },
      {
        id: "sub_id2",
        title: "Sub ID 2",
        value: "",
      },
    ];
    this.stringSubId = "";
    this.changeTrackingLink();
  }

  handleAffClickCheckbox(event: any) {
    this.affClickIdChecked = event.target.checked;
    this.affClickId.value = "";
    this.changeTrackingLink();
  }

  resetMobileParams() {
    this.mobileParams = [
      {
        id: "idfa",
        title: "Apple ios idfa",
        value: "",
      },
      {
        id: "gaid",
        title: "Google android gaid",
        value: "",
      },
    ];
    this.stringMobileParams = "";
    this.changeTrackingLink();
  }

  handleMobileParamsCheckbox(event: any) {
    this.mobileParamsChecked = event.target.checked;
    this.resetMobileParams();
  }

  async shortURL() {
    const url =
      "https://tinyurl.com/api-create.php?url=" +
      encodeURIComponent(this.originalTrackingLink);
    try {
      const response = await fetch(url);
      if (response.ok) {
        this.sortTrackingLink = await response.text();
        this.toastr.showSuccess(this.translate.instant("Tạo link thành công"));
      }
    } catch (error) {}
  }

  async createLink() {
    if (this.offerId == 263) {
      if (this.valueLink && this.valueLink.startsWith("https://shopee.vn/")) {
        this.originalTrackingLink = `${this.trackingLinkFull}&deep_link=https://shope.ee/an_redir?origin_link=${encodeURIComponent(this.valueLink + "&affiliate_id=17107970000")}`;
      } else {
        this.originalTrackingLink = `${this.trackingLinkFull}&deep_link=https://shope.ee/an_redir?origin_link=${encodeURIComponent("https://shopee.vn/" + "&affiliate_id=17107970000")}`;
      }
    } else if (this.offerId == 262) {
      if (
        this.valueLink &&
        this.valueLink.startsWith("https://www.lazada.vn/")
      ) {
        this.originalTrackingLink = `${this.trackingLinkFull}&deep_link=https://c.lazada.vn/t/c.0Eacqy?url=${this.valueLink}`;
      } else {
        this.originalTrackingLink = `${this.trackingLinkFull}&deep_link=https://c.lazada.vn/t/c.0Eacqy?url=https://www.lazada.vn/`;
      }
    } else if (this.offerId == 425) {
      if (this.valueLink && this.valueLink.startsWith("https://tiki.vn/")) {
        this.originalTrackingLink = `${this.trackingLinkFull}&deep_link=https://ti.ki/oTxhTytA/UX6MURGN?TIKI_URI=${encodeURIComponent(this.valueLink)}`;
      } else {
        this.originalTrackingLink = `${this.trackingLinkFull}&deep_link=https://ti.ki/oTxhTytA/UX6MURGN?TIKI_URI=https://tiki.vn/`;
      }
    }
    await this.shortURL();
  }

  onMouseEnter(icon: any) {
    icon.iconColor = "#FFFFFF";
    icon.color = "#308DE3";
  }

  onMouseLeave(icon: any) {
    icon.iconColor = "#308DE3";
    icon.color = "#2E2E2E";
  }

  @ViewChild("heightCardInfo") heightCardInfo: ElementRef;
  @ViewChild("heightCardLink") heightCardLink: ElementRef;

  handleHeightCardDes() {
    setTimeout(() => {
      const heightCardInfo = (<HTMLElement>(
        this.heightCardInfo.nativeElement
      )).getBoundingClientRect().height;
      const heightCardLink = (<HTMLElement>(
        this.heightCardLink.nativeElement
      )).getBoundingClientRect().height;
      this.heightCardDes = heightCardInfo + heightCardLink + 24 + "px";
    }, 6000);
  }

  openScrollableModal(content: TemplateRef<any> | ElementRef) {
    const modalRef = this.modalService.open(content, {
      scrollable: true,
      centered: true,
      size: "lg",
    });
  }

  getIdAffiliate(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.userService.getUserProfile().subscribe((data: { id: number }) => {
        this.affiliateId = data.id;
        resolve();
      });
    });
  }

  async onChaneLandingPage(event: any) {
    if (!this.affiliateId) {
      await this.getIdAffiliate();
    }
    this.checkTrackingLink = false;
    this.typeLandingPage = event.type;
    if (this.typeLandingPage == 1) {
      this.trackingLink = `${this.parseTrackingDomain.name}/click?a=${this.affiliateId}&o=${this.offerId}`;
    } else if (this.typeLandingPage == 3) {
      this.trackingLink = `${this.parseTrackingDomain.name}/click?a=${this.affiliateId}&o=${this.offerId}&link_id=${event.id}`;
    } else {
      this.trackingLink = "";
    }
    this.checkDirectLink = false;
    this.genDirectLink(event);
    this.changeTrackingLink();
    this.setImpressionsPixel();
  }

  changeTrackingLink() {
    this.trackingLinkFull = this.trackingLink;
    if (this.stringSubId) {
      this.trackingLinkFull += this.stringSubId;
    }
    if (this.affClickId.value) {
      this.trackingLinkFull += `&${this.affClickId.id}=${this.affClickId.value}`;
    }
    if (this.stringMobileParams) {
      this.trackingLinkFull += this.stringMobileParams;
    }
    this.setImpressionsPixel();
  }

  keyUpAddSubId() {
    this.stringSubId = "";
    this.subIds.forEach((subId) => {
      if (subId.value) {
        this.stringSubId += `&${subId.id}=${subId.value}`;
      }
    });
    this.changeTrackingLink();
  }

  keyUpMobileParams() {
    this.stringMobileParams = "";
    this.mobileParams.forEach((mobileParam) => {
      if (mobileParam.value) {
        this.stringMobileParams += `&${mobileParam.id}=${mobileParam.value}`;
      }
    });
    this.changeTrackingLink();
  }

  handleRequestOffer() {
    if (this.loadRequest) {
      return;
    }

    this.loadRequest = true;
    let params = {
      offer_id: this.offerId,
    };
    this.offerServices.requestOffer(params).subscribe(
      () => {
        this.toastr.showSuccess(
          this.translate.instant("offers.detail.request_offer_success")
        );
        this.loadDetailPage = true;
        this.getDetailOffer();
        this.loadRequest = false;
      },
      () => {
        this.toastr.showError(
          this.translate.instant("offers.detail.request_offer_failed")
        );
      }
    );
  }

  getDetailOffer() {
    this.offerServices.getDetailOffer(this.offerId).subscribe(
      (data) => {
        this.visibleTypeSelect = data?.visible_type_selected[0]?.requests[0];
        const today = this.formatDateService.formatDate(
          new Date(),
          "YEAR-MONTH-DAY"
        );
        const startDate = data.start_time_exclusive;
        const endDate = data.end_time_exclusive;
        const isTodayInRange = startDate <= today && today <= endDate;

        if (
          data?.exclusive_commission == 1 &&
          !data?.register_exclusive &&
          isTodayInRange &&
          (data?.visible_type == 1 || this.visibleTypeSelect?.status == 1)
        ) {
          this.disableButtonUpgradeOffer = false;
        }

        this.checkOrderApi = +data["create_order_api"];
        this.detailOffer = data;
        this.offerImage = data["image"]
          ? data["image"]
          : "assets/images/offer/offer_default.svg";
        this.offerName = data["title"] ? data["title"] : "";
        if (data?.goals) {
          this.offerPayout = data["goals"][0]["payout_for_affiliate"]
            ? data["goals"][0]["payout_for_affiliate"]
            : data["goals"][0]["payout"];
          this.offerType = data["goals"][0]["goal_type_name"];
        }
        data?.targeting
          ? (this.offerCountries =
              data["targeting"]["geo"]["allowed"].split(";"))
          : (this.offerCountries = []);
        if (data?.tags_selected) {
          this.offerTag = data["tags_selected"].map((data: any) => data);
          this.checkLenghtOfferTag = this.offerTag.length > 1;
        }
        const description = JSON.parse(this.detailOffer?.detail) as any[];
        if (description.length > 0) {
          description.map((data: { key: string; value: any }) => {
            const key = data.key
              .replace(/&nbsp;/g, " ")
              .replace(/(<([^>]+)>)/g, "")
              .replace(/:/g, " ")
              .replace(/\d+./g, "")
              .trim();
            const value = data.value;
            let obj = {
              key: key,
              value: value,
            };
            this.descriptionOb.push(obj);
          });
        }

        this.loadDetailPage = false;
        this.params.tags = data["tags"];
        this.getListSimilarOffers(this.params);
        this.getIdAffiliate().then(() => {
          this.orderSendApi =
            this.orderSendApiUrl +
            `?campaign_id=${this.offerId}&pub_id=${this.affiliateId}`;
        });
        this.parseTrackingDomain = data.tracking_domain;

        this.landingPages = data.links;
        const defaultLandingPage = this.landingPages.find(
          (page: any) => page.type === 1
        );
        if (defaultLandingPage) {
          this.selectedLandingPage = defaultLandingPage.id;
          this.onChaneLandingPage(defaultLandingPage);
        }
        this.enableDirectLink = Boolean(data.enable_direct_link);
        if (this.enableDirectLink) {
          this.genDirectLink(defaultLandingPage);
        }
      },
      () => {
        this.router.navigate(["offers"]).then();
      }
    );
  }

  setImpressionsPixel() {
    this.impressionsPixel = `<img src="${this.trackingLinkFull.replace("/click?", "/imp?")}" height="1" width="1" />`;
  }

  getListSimilarOffers(params: any) {
    this.offerServices.getAllOffer({ tags: params.tags }).subscribe((data) => {
      this.loadSimilarOffer = false;
      if (data.results?.length > 1) {
        const arr: any[] = data.results;
        const return_arr = [];
        for (let i = 0; i < 4; i++) {
          const random_int = Math.round(Math.random() * (arr.length - 1));
          if (this.detailOffer.id === arr[random_int].id) {
            i--;
          } else {
            return_arr.push(arr[random_int]);
            arr.splice(random_int, 1);
            if (arr.length <= 1 && arr[0].id === this.detailOffer.id) {
              break;
            }
          }
        }
        this.similarOffers = return_arr;
      } else {
        this.similarOffers = [];
        this.noDataSimilarOffer = true;
      }
    });
  }

  isNumber(value: any): boolean {
    return !isNaN(parseFloat(value));
  }

  copyOderSendApi() {
    this.copy(this.orderSendApi);
  }

  copyTrackingLink() {
    this.copy(this.trackingLinkFull);
  }

  openModalQr(template: any) {
    this.openScrollableModal(this.modalGenerateQr);
    this.qrData = this.trackingLinkFull;
  }

  downloadQr() {
    if (!this.hiddenQrCode) {
      console.error("QR Code component not found!");
      return;
    }

    // Lấy canvas từ QR Code
    const qrCodeInstance: any = this.hiddenQrCode;
    const qrCanvas =
      qrCodeInstance.qrcElement?.nativeElement.querySelector("canvas");

    if (!qrCanvas) {
      console.error("Canvas not found!");
      return;
    }

    // Xuất thành ảnh và tải xuống
    const link = document.createElement("a");
    link.href = qrCanvas.toDataURL("image/png");
    link.download = "qrcode_tracking_link.png";
    link.click();
  }

  copyImpressons() {
    this.copy(this.impressionsPixel);
  }

  copy(data: any) {
    this.copyService.copyToClipboard(data);
  }

  copyDirectLink() {
    this.copy(this.directLink);
  }

  async genDirectLink(landingPage?: any, paramOptions?: string[]) {
    if (!this.enableDirectLink) {
      return;
    }
    const defaultPage = landingPage || this.selectedLandingPage;
    const selectLadingPage =
      this.landingPages?.length > 0 &&
      this.landingPages.find((page) => page.id == defaultPage.id);
    const url = new URL(selectLadingPage.url);
    const searchParams = url.searchParams;
    const params: string[] = [];
    searchParams.forEach((value, key) => {
      if (value.includes("{click_id}")) {
        const newValue = `${this.offerId}-${this.affiliateId}`;
        return params.push(`${key}=${newValue}`);
      }
      if (value == "{affiliate_id}") {
        return params.push(`${key}=${this.affiliateId}`);
      }
      if (value == "{offer_id}") {
        return params.push(`${key}=${this.offerId}`);
      }
      return params.push(`${key}=${value}`);
    });
    if (this.typeLandingPage == 3) {
      params.push(`link_id=${landingPage.id}`);
    }
    if (paramOptions && paramOptions.length > 0) {
      params.push(...paramOptions);
    }
    if (selectLadingPage) {
      this.directLink = [
        [url.origin, url.pathname].join(""),
        params.join("&"),
      ].join("?");
    }
  }
}
